import { getEnv } from "./utils/env";

interface BlockTime {
  changedStartBlock: number; // Block Number when the block already changed
  changedEndBlock?: number; // Optional Block Number when the block already changed
  blockTime: number; // Block Time in seconds
}

const blockTimeMainnet: BlockTime[] = [
  {
    changedStartBlock: 0,
    changedEndBlock: 48773576, // Block Number when the block already changed
    blockTime: 3, // Block Time in seconds
  },
  {
    changedStartBlock: 48773576,
    changedEndBlock: 52337091,
    blockTime: 1.5, // Block Time in seconds
  },
  {
    changedStartBlock: 52337091,
    blockTime: 0.75, // Block Time in seconds
  },
];

const blockTimeTestnet: BlockTime[] = [
  {
    changedStartBlock: 0,
    changedEndBlock: 50993004,
    blockTime: 3, // Block Time in seconds
  },
  {
    changedStartBlock: 50993004,
    changedEndBlock: 52552978,
    blockTime: 1.5, // Block Time in seconds
  },
  {
    changedStartBlock: 52552978,
    blockTime: 0.75, // Block Time in seconds
  },
];

const blockTimeList =
  getEnv("REACT_APP_IS_PROD")?.toUpperCase() === "TRUE"
    ? blockTimeMainnet
    : blockTimeTestnet;

export { blockTimeList };
